import { useEffect, useState } from "react";
import api, { currency } from "@/lib/api";

export default function Analytics() {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        (async () => { try { const { data } = await api.get("/analytics/overview"); setStats(data); } catch {} })();
    }, []);
    if (!stats) return <div className="text-gray-500">Loading analytics…</div>;
    return (
        <div className="space-y-6" data-testid="analytics-page">
            <div>
                <p className="text-[10px] uppercase tracking-[0.28em] text-komma-gold">Board View</p>
                <h1 className="font-serif text-3xl text-komma-navy">Portfolio Analytics</h1>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[["Total Loans", stats.total_loans], ["Customers", stats.total_customers],
                  ["Approved", stats.approved], ["Rejected", stats.rejected]].map(([l, v]) => (
                    <div key={l} className="komma-card p-5">
                        <p className="text-[10px] uppercase tracking-[0.24em] text-gray-500">{l}</p>
                        <p className="font-serif text-3xl text-komma-navy mt-2">{v}</p>
                    </div>
                ))}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="komma-card p-6">
                    <p className="text-[10px] uppercase tracking-[0.24em] text-gray-500">Pipeline Value</p>
                    <p className="font-serif text-4xl text-komma-navy mt-2">{currency(stats.pipeline_value)}</p>
                    <div className="komma-gold-hairline my-4" />
                    <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">By Type</p>
                    <div className="space-y-2">
                        {(stats.by_type || []).map((r) => (
                            <div key={r._id} className="flex justify-between text-sm">
                                <span className="capitalize text-komma-navy">{r._id}</span>
                                <span className="font-semibold">{currency(r.amount)}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="komma-card p-6">
                    <p className="text-[10px] uppercase tracking-[0.24em] text-gray-500">Disbursed Value</p>
                    <p className="font-serif text-4xl text-komma-gold-dark mt-2">{currency(stats.disbursed_value)}</p>
                    <div className="komma-gold-hairline my-4" />
                    <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">By Status</p>
                    <div className="space-y-2">
                        {(stats.by_status || []).map((r) => (
                            <div key={r._id} className="flex justify-between text-sm">
                                <span className="capitalize text-komma-navy">{r._id}</span>
                                <span className="font-semibold">{r.count}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
